import React from 'react';
import PropTypes from 'prop-types';
import { kebabCase } from 'lodash';
import { Modal, ModalBody, ModalFooter, Button } from 'reactstrap';
import OptionNestedPickerField from './optionNestedPickerField';
const OptionNestedPickerModal = ({
  allowsMultipleSelection,
  allowsOther,
  allowsParentSelection,
  className,
  closeModal,
  isOpen,
  label: _label = null,
  onChange,
  options,
  value
}) => /*#__PURE__*/React.createElement(Modal, {
  className: `t-onpm-${kebabCase(_label || 'no-label')}`,
  isOpen: isOpen
}, /*#__PURE__*/React.createElement(ModalBody, null, _label ? /*#__PURE__*/React.createElement("h2", null, _label) : null, /*#__PURE__*/React.createElement(OptionNestedPickerField, {
  allowsMultipleSelection: allowsMultipleSelection,
  allowsOther: allowsOther,
  allowsParentSelection: allowsParentSelection,
  backLabel: _label || 'back',
  className: className,
  onChange: onChange,
  options: options,
  value: value
})), /*#__PURE__*/React.createElement(ModalFooter, null, /*#__PURE__*/React.createElement(Button, {
  className: "t-ts-button-done",
  onClick: closeModal
}, "Done")));
OptionNestedPickerModal.propTypes = {
  label: PropTypes.string,
  isOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  allowsMultipleSelection: PropTypes.bool.isRequired,
  allowsOther: PropTypes.bool.isRequired,
  allowsParentSelection: PropTypes.bool.isRequired,
  className: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({}), PropTypes.array]).isRequired
};
export default OptionNestedPickerModal;